// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VnbqmfYviVcHQeASFv65 {

    margin-top: 1.25rem;

    display: flex;

    justify-content: flex-end;

    gap: 0.75rem
}

.Z0gZCeAMOS0mMsNQoeVQ {

    height: 65px;

    width: 180px;

    border-style: none !important;

    --tw-bg-opacity: 1;

    background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1));

    font-family: Noto Sans;

    font-size: 14px;

    font-size: 1.875rem;

    line-height: 2.25rem;

    font-weight: 500;

    --tw-text-opacity: 1;

    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

@media (min-width: 1024px) {

    .Z0gZCeAMOS0mMsNQoeVQ {

        height: 38px;

        width: 137px;

        font-size: 1rem;

        line-height: 1.5rem
    }
}

.Z0gZCeAMOS0mMsNQoeVQ:hover {

    --tw-bg-opacity: 1 !important;

    background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1)) !important;

    --tw-text-opacity: 1 !important;

    color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important
}

.QO9gOKREbE5dUzmUrQx3 {

    height: 65px;

    width: 180px;

    --tw-border-opacity: 1;

    border-color: rgb(3 120 209 / var(--tw-border-opacity, 1));

    --tw-bg-opacity: 1;

    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));

    font-size: 1.875rem;

    line-height: 2.25rem;

    --tw-text-opacity: 1;

    color: rgb(3 120 209 / var(--tw-text-opacity, 1))
}

@media (min-width: 1024px) {

    .QO9gOKREbE5dUzmUrQx3 {

        height: 38px;

        width: 137px;

        font-size: 1rem;

        line-height: 1.5rem
    }
}

.QO9gOKREbE5dUzmUrQx3:hover {

    --tw-border-opacity: 1 !important;

    border-color: rgb(3 120 209 / var(--tw-border-opacity, 1)) !important;

    --tw-bg-opacity: 1 !important;

    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;

    --tw-text-opacity: 1 !important;

    color: rgb(3 120 209 / var(--tw-text-opacity, 1)) !important
}
.rUC0vbVjh2NR3W6vGA1A {

    font-size: 27px;

    font-weight: 700
}
@media (min-width: 1024px) {

    .rUC0vbVjh2NR3W6vGA1A {

        font-size: 1.125rem;

        line-height: 1.75rem
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/SignaturePad/SignaturePad.module.css"],"names":[],"mappings":"AACE;;IAAA,mBAAkC;;IAAlC,aAAkC;;IAAlC,yBAAkC;;IAAlC;AAAkC;;AAIlC;;IAAA,YAA4J;;IAA5J,YAA4J;;IAA5J,6BAA4J;;IAA5J,kBAA4J;;IAA5J,0DAA4J;;IAA5J,sBAA4J;;IAA5J,eAA4J;;IAA5J,mBAA4J;;IAA5J,oBAA4J;;IAA5J,gBAA4J;;IAA5J,oBAA4J;;IAA5J;AAA4J;;AAA5J;;IAAA;;QAAA,YAA4J;;QAA5J,YAA4J;;QAA5J,eAA4J;;QAA5J;IAA4J;AAAA;;AAI5J;;IAAA,6BAA8B;;IAA9B,qEAA8B;;IAA9B,+BAA8B;;IAA9B;AAA8B;;AAI9B;;IAAA,YAA6G;;IAA7G,YAA6G;;IAA7G,sBAA6G;;IAA7G,0DAA6G;;IAA7G,kBAA6G;;IAA7G,4DAA6G;;IAA7G,mBAA6G;;IAA7G,oBAA6G;;IAA7G,oBAA6G;;IAA7G;AAA6G;;AAA7G;;IAAA;;QAAA,YAA6G;;QAA7G,YAA6G;;QAA7G,eAA6G;;QAA7G;IAA6G;AAAA;;AAI7G;;IAAA,iCAA8C;;IAA9C,qEAA8C;;IAA9C,6BAA8C;;IAA9C,uEAA8C;;IAA9C,+BAA8C;;IAA9C;AAA8C;AAG9C;;IAAA,eAAuC;;IAAvC;AAAuC;AAAvC;;IAAA;;QAAA,mBAAuC;;QAAvC;IAAuC;AAAA","sourcesContent":[".buttonWrapper {\n  @apply flex justify-end gap-3 mt-5;\n}\n\n.applyButton {\n  @apply bg-primary text-white w-[180px] h-[65px] lg:w-[137px] lg:h-[38px] text-dashboardMain font-dashboardMain font-inter !border-none text-3xl lg:text-base;\n}\n\n.applyButton:hover {\n  @apply !bg-primary !text-white;\n}\n\n.clearButton {\n  @apply bg-white text-primary border-primary w-[180px] h-[65px] lg:w-[137px] lg:h-[38px] text-3xl lg:text-base;\n}\n\n.clearButton:hover {\n  @apply !bg-white !text-primary !border-primary;\n}\n.modalTitle {\n  @apply text-[27px] lg:text-lg font-bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonWrapper": `VnbqmfYviVcHQeASFv65`,
	"applyButton": `Z0gZCeAMOS0mMsNQoeVQ`,
	"clearButton": `QO9gOKREbE5dUzmUrQx3`,
	"modalTitle": `rUC0vbVjh2NR3W6vGA1A`
};
export default ___CSS_LOADER_EXPORT___;
